import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import activityReducer from './activity/ActivitySlice';
import clickOutsideReducer from './clickOutside/ClickOutsideSlice';
import commentsReducer from './comments/CommentsSlice';
import channelsReducer from './channels/ChannelsSlice';
import checkoutReducer from './checkout/CheckoutSlice';
import creatorsReducer from './creators/CreatorsSlice';
import itemsReducer from './items/ItemsSlice';
import rebuzzReducer from './rebuzz/RebuzzSlice';
import loginFormReducer from './auth/login/LoginSlice';
import messengerReducer from './messenger/MessengerSlice';
import organizationsReducer from './organizations/OrganizationsSlice';
import profileReducer from './currentUser/CurrentUserSlice';
import recentReducer from './recent/RecentsSlice';
import registerFormReducer from './auth/register/RegisterSlice';
import rolesReducer from './roles/RolesSlice';
import searchReducer from './search/SearchSlice';
import settingsReducer from './settings/SettingsSlice';
import sidebarFacetsReducer from './sidebarFacets/SidebarFacetsSlice';
import streamsReducer from './streams/StreamsSlice';
import schedulingReducer from './scheduling/SchedulingSlice';
import suggestedReducer from './suggested/SuggestedSlice';
import topicsReducer from './topics/TopicsSlice';
import uiReducer from './ui/UiSlice';
import usersReducer from './users/UsersSlice';

const authReducer = combineReducers({
  login: loginFormReducer,
  register: registerFormReducer,
});

export default configureStore({
  reducer: {
    activity: activityReducer,
    auth: authReducer,
    channels: channelsReducer,
    clickOutside: clickOutsideReducer,
    checkout: checkoutReducer,
    currentUser: profileReducer,
    comments: commentsReducer,
    creators: creatorsReducer,
    items: itemsReducer,
    messenger: messengerReducer,
    organizations: organizationsReducer,
    rebuzz: rebuzzReducer,
    recent: recentReducer,
    search: searchReducer,
    settings: settingsReducer,
    sidebarFacets: sidebarFacetsReducer,
    streams: streamsReducer,
    scheduling: schedulingReducer,
    roles: rolesReducer,
    suggested: suggestedReducer,
    topics: topicsReducer,
    ui: uiReducer,
    users: usersReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: { warnAfter: 128 },
    }),
});
